import classNames from 'classnames';
import { FC } from 'react';

import IconButton from '../IconButton/IconButton';
import style from './CloseButton.module.scss';

interface CloseButtonProps {
  alignment: 'topRight';
  onClick: () => void;
}

export const CloseButton: FC<CloseButtonProps> = ({ alignment, onClick }) => {
  return (
    <IconButton
      className={classNames(style.closeButton, style[alignment])}
      icon="close"
      onClick={onClick}
    />
  );
};
